/**
 * Dados cadastrais oficiais da empresa proprietária e controladora do AutoFluxo.
 * Fonte única: a tela de login e a Política de Privacidade precisam exibir
 * exatamente os mesmos textos, pois a Meta faz o cruzamento entre eles.
 */

export const COMPANY_NAME = 'IMPERIAL CAR INTERMEDIAÇÃO & COMÉRCIO DE VEÍCULOS LTDA';
export const COMPANY_TRADE_NAME = 'Imperial Car Negócios';
export const COMPANY_CNPJ = '67.678.178/0001-67';
export const COMPANY_ADDRESS =
  'Av. General Osório de Paiva, 4590, Galpão 2 — Bom Jardim, Fortaleza/CE — CEP 60.731-534';
export const COMPANY_EMAIL = 'contato@imperialcar.com.br';
export const COMPANY_PHONE = '(85) 9916-1693';
export const COMPANY_PHONE_HREF = 'tel:+558599161693';

/** Canal do encarregado de dados (DPO) exibido na Política de Privacidade. */
export const CONTACT_EMAIL = 'contato@autofluxo.app';

/** Rota interna da Política de Privacidade pública. */
export const PRIVACY_POLICY_PATH = '/politica-de-privacidade';
